import { initialsFrom } from '../text/initials';

export interface NamedPerson {
  displayName: string | null;
  email: string | null;
}

/** "ada.lovelace@example.com" → "Ada Lovelace". */
function nameFromEmail(email: string): string {
  const local = email.split('@')[0] ?? '';
  return local
    .split(/[._-]+/)
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ');
}

/**
 * The one rule for showing a person: their saved name, otherwise a readable
 * name from their email, otherwise `fallback`.
 */
export function formatPersonName(person: NamedPerson | null | undefined, fallback: string): string {
  const saved = person?.displayName?.trim();
  if (saved) return saved;
  const derived = person?.email ? nameFromEmail(person.email) : '';
  return derived || fallback;
}

export function formatFirstName(person: NamedPerson | null | undefined, fallback = 'there'): string {
  return formatPersonName(person, fallback).split(/\s+/)[0] || fallback;
}

export function personInitials(person: NamedPerson | null | undefined, fallback = '?'): string {
  return initialsFrom(formatPersonName(person, ''), fallback);
}
